/* eslint-disable prefer-destructuring */
import _ from "lodash"
import moment from "moment"
import { common } from "./styles"

function formatTooltipSeriesOf(p, chartOpts) {
  const color = p.color
  const seriesName = p.series.name

  const isCreation = _.get(chartOpts, "plotOptions.series.custom.creation")
  const rawValue = (!isCreation && p.point.change) || p.y
  const value = rawValue.toFixed(2)
  return `<span style="color: ${color};">•</span> ${seriesName}: ${value}`
}

export default function tooltipPlugin(chartOpts) {
  _.set(chartOpts, "tooltip.backgroundColor", common.white2)
  _.set(chartOpts, "tooltip.borderColor", common.white2)
  _.set(chartOpts, "tooltip.borderWidth", 1)
  _.set(chartOpts, "tooltip.style", { color: common.textColor })

  _.set(chartOpts, "tooltip.xDateFormat", "%d/%m/%Y")

  // eslint-disable-next-line func-names
  // do not convert into arrow func, this will break `this` usage
  _.set(chartOpts, "tooltip.formatter", function () {
    const seriesArr = this.points.map((p) =>
      formatTooltipSeriesOf(p, chartOpts)
    )
    return [moment(this.x).format("L"), ...seriesArr]
  })

  return chartOpts
}
